import { render } from "./UiCropper.vue?vue&type=template&id=48c3fc02&ts=true&lang=pug"
import script from "./UiCropper.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiCropper.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__